import { BUSCAR_USUARIOS_EMPRESA_AGENCIA } from '../../actions/types'

const initialState = null

export default function reducerResumoFinanceiro (state = initialState, action ) {
  switch (action.type) {
    case BUSCAR_USUARIOS_EMPRESA_AGENCIA: {
      return action.payload.data;
    }

    default: {
      return state
    }
  }
}
